import { render, staticRenderFns } from "./ScoreFile.vue?vue&type=template&id=7932e9fa&scoped=true"
import script from "./ScoreFile.vue?vue&type=script&lang=js"
export * from "./ScoreFile.vue?vue&type=script&lang=js"
import style0 from "./ScoreFile.vue?vue&type=style&index=0&id=7932e9fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7932e9fa",
  null
  
)

export default component.exports